export const geoApiOptions = {
    method: 'GET',
    headers: {
        'X-RapidAPI-Key': '180096e319mshc3316478facce6ep1b02c6jsn5e289e4c8a23',
        'X-RapidAPI-Host': 'wft-geo-db.p.rapidapi.com'
    }
};

export const GEO_API_URL = 'https://wft-geo-db.p.rapidapi.com/v1/geo'

export const WEATHER_API_URL = 'https://api.openweathermap.org/data/2.5'
export const WEATHER_API_KEY = '3a0559866dfe77555ecef943813e557e'

export const FORECAST_API_KEY = 'https://api.open-meteo.com/v1'




